import { defineMutators } from '@rocicorp/zero';
import { basicData } from './basic-data.mutators.js';
import { compoundMappings, compoundOrders } from './compounders.mutators.js';
import { consumables } from './consumables.mutators.js';
import { customers } from './customer.mutators.js';
import { activeSubstances } from './drug-catalog/active-substance.mutators.js';
import { medicationProfiles } from './drug-catalog/medication-profile.mutators.js';
import { solutions } from './drug-catalog/solution.mutators.js';
import { supportiveMedications } from './drug-catalog/supportive-medication.mutators.js';
import { drugsCategories } from './drugs-category.mutators.js';
import { locations } from './location.mutators.js';
import { patients } from './patient.mutators.js';
import { patientsTherapies } from './patients-therapies/patients-therapies.mutators.js';
import { pharmacies } from './pharmacy.mutators.js';
import { protocols } from './protocol.mutators.js';
import { reportViews } from './report-views.mutators.js';
import { scaleAlibis } from './scale-alibi.mutators.js';
import { sections } from './section.mutators.js';
import { settings } from './settings.mutators.js';
import { stocks } from './stocks.mutators.js';
import { tradeNames } from './trade-name.mutators.js';
import { userGroups } from './user-group.mutators.js';
import { users } from './user.mutators.js';
import { wards } from './ward.mutators.js';
export { AddApplicationFormSchema, AddBasicDataItemSchema, AddGeneralPhysicianSchema, AddInsuranceCompanySchema, AddMedicineFormSchema, BasicDataItemSchema, UpdateApplicationFormSchema, UpdateBasicDataItemSchema, UpdateGeneralPhysicianSchema, UpdateInsuranceCompanySchema, UpdateMedicineFormSchema, } from './basic-data.mutators.js';
export { AddCompoundMappingSchema, RetryCompoundOrderSchema, UpdateCompoundMappingSchema, } from './compounders.mutators.js';
export { AddConsumableSchema, ConsumableSchema, UpdateConsumableSchema } from './consumables.mutators.js';
export { AddCustomerSchema, UpdateCustomerSchema } from './customer.mutators.js';
export { ActiveSubstanceSchema, AddActiveSubstanceSchema, UpdateActiveSubstanceSchema, } from './drug-catalog/active-substance.mutators.js';
export { AddMedicationProfileInputSchema } from './drug-catalog/medication-profile.mutators.js';
export { AddSolutionSchema, SolutionSchema, UpdateSolutionSchema } from './drug-catalog/solution.mutators.js';
export { AddSupportiveMedicationSchema, SupportiveMedicationSchema, UpdateSupportiveMedicationSchema, } from './drug-catalog/supportive-medication.mutators.js';
export { AddDrugItemSchema, AddMedicationProfileSchema } from './drug-catalog/utils/index.js';
export { AddDrugsCategorySchema, UpdateDrugsCategorySchema } from './drugs-category.mutators.js';
export { AddLocationSchema } from './location.mutators.js';
export { AddPatientSchema, AssignProtocolToPatientSchema, ImportPatientFromHl7Schema, MergePatientsSchema, TherapyParameterSchema, UpdateInsuranceSchema, UpdatePatientSchema, } from './patient.mutators.js';
export { ABORT_CONSUMABLE_STATUSES, ABORT_DRUG_STATUSES, AbortMaterialKind, AbortMaterialStatus, AbortProductionSchema, AbortReason, QaRejectReason, AddPatientTherapySequenceObservation, RemakePatientTherapySequenceSchema, RemovablePatientTherapyValidation, LabelPrintPlace, SaveCleanroomStateSchema, SendEventSchema as SendPatientTherapySequenceEventSchema, SwitchToVolumetricSchema, UpdateChairSchema, } from './patients-therapies/patients-therapies.mutators.js';
export { CompleteProductionEventBody, PatientTherapySequenceEvent, PatientTherapySequenceEventType, PatientTherapySequenceMachine, PharmacistValidateEventBody, ProductionWeighing, ReturnToPharmacyEventBody, } from './patients-therapies/state-machine.js';
export { AddPharmacySchema, UpdatePharmacySchema } from './pharmacy.mutators.js';
export { DeleteReportViewSchema, ReorderReportViewsSchema, SaveReportViewSchema, UpdateReportViewSchema, } from './report-views.mutators.js';
export { AddScaleAlibiSchema } from './scale-alibi.mutators.js';
export { AddSectionSchema, DeleteSectionBatchSchema, UpdateSectionBatchStatusSchema, UpdateSectionSchema, } from './section.mutators.js';
export { UpdateSettingsSchema } from './settings.mutators.js';
export { AcknowledgeExpiredBatchSchema, AddBatchSchema, AddProductionRestVialsSchema, AddRestVialSchema, AddReturnSchema, DiscardBatchSchema, UpdateBatchSchema, UpdateRestVialsLocationSchema, UpdateReturnLocationSchema, } from './stocks.mutators.js';
export { ActiveSubstanceTradeNameSchema, ActiveSubstanceTradeNameSchemaFields, AddTradeNameSchema, BaseTradeNameSchema, SolutionTradeNameSchema, SolutionTradeNameSchemaFields, SupportiveMedicationTradeNameTradeNameSchema, SupportiveMedicationTradeNameTradeNameSchemaFields, tradeNameRefinement, TradeNameSchema, UpdateTradeNameSchema, } from './trade-name.mutators.js';
export { AddUserGroupSchema, UpdateUserGroupSchema } from './user-group.mutators.js';
export { AddUserSchema, SetupPasswordSchema, UpdateUserSchema, UserSectionSchema } from './user.mutators.js';
export { DeleteResourceSchema, UpdateResourceStatusSchema } from './util.js';
export { AddProtocolSchema, UpdateProtocolBatchStatusSchema, UpdateProtocolSchema } from './utils/protocols.js';
export { AddStabilityRuleSchema, resolveStabilityRuleLabelCopies, UpdateStabilityRuleSchema, } from './utils/stability-rules.js';
export { AddWardSchema, DeleteWardBatchSchema, UpdateWardBatchStatusSchema, UpdateWardSchema } from './ward.mutators.js';
/**
 * These mutators are shared - they run on both client and server-side.
 *
 * What you write here MUST validate the auth context in such a way that first and foremost it works client-side (i.e. in the browser).
 *
 * If you wish to add extra validation checks that CAN ONLY run on the server, look inside the `server` package.
 */
export const mutators = defineMutators({
    locations,
    sections,
    wards,
    users,
    userGroups,
    activeSubstances,
    medicationProfiles,
    tradeNames,
    consumables,
    pharmacies,
    patients,
    customers,
    basicData,
    protocols,
    drugsCategories,
    solutions,
    supportiveMedications,
    patientsTherapies,
    stocks,
    settings,
    reportViews,
    scaleAlibis,
    compoundMappings,
    compoundOrders,
});
//# sourceMappingURL=index.js.map